export const APP_CONFIG = {
  // baseDomain: 'http://127.0.0.1:8200',
  baseDomain: 'https://clapi.nghienorder.vn',
  mediaDomain: 'https://media.nghienorder.vn',
  domain: 'https://nghienorder.vn',
  authSetting: {
    tokenName: 'token',
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
};
